import { ReadonlyHeaders } from 'next/dist/server/web/spec-extension/adapters/headers';

import { DOMAINS } from './constants';
import { X_FORWARDED_HOST, X_URL_HEADER } from './variables';

export type ServerLocation = URL;

export const ensureClientHost = (serverHost: string) => {
  let ensuredClientHostname = serverHost;

  if (typeof window !== 'undefined') {
    const clientHost = `${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    if (serverHost !== clientHost) {
      ensuredClientHostname = clientHost;
    }
  }

  return ensuredClientHostname;
};

export const getServerHostUrl = (headersList: ReadonlyHeaders): string => {
  const host =
    headersList.get(X_FORWARDED_HOST) ||
    headersList.get('host') ||
    DOMAINS.MAIN;

  return host;
};

export const getServerLocation = (
  headersList: ReadonlyHeaders
): ServerLocation => {
  const xUrl = headersList.get(X_URL_HEADER);

  if (!xUrl) return new URL(`https://${DOMAINS.MAIN}`);

  return new URL(xUrl);
};

export const checkIsMobileDevice = (headersList: ReadonlyHeaders) => {
  const userAgent = headersList.get('user-agent') || '';

  return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune|Tablet|PlayBook|Nexus 7/i.test(
    userAgent
  );
};
